export default [
    {
        path: "areas-module",
        name: "settings-areas-module",
        component: () => import("@/views/settings/views/areas-module/AreasModule.vue"),
        meta: {
            section: 25,
            pageTitle: "Settings",
            breadcrumb: [
                {
                    text: "Areas by module"
                }
            ],
        }
    }
];